import highcharts3d from "highcharts/highcharts-3d.src";
import { useContext, useEffect, useState } from "react";
import { PulseLoader } from "react-spinners";
import CampaignContext from "../../../contexts/CampaignContext";
import restService from "../../../restService";

const PieChart = ({ dimensions, Highcharts, HighchartsReact, state }) => {
  const [campaign] = useContext(CampaignContext);
  const [direction, setDirection] = useState("horizontal");
  const [vAlign, setVAlign] = useState("middle");
  const [lAlign, setLAlign] = useState("right");
  const [chartWidth, setChartWidth] = useState(450);
  const [loading, setLoading] = useState(true);
  const [rewards, setRewards] = useState([]);

  // const [state, setState] = useState([
  //   {
  //     startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
  //     endDate: new Date().setHours(23, 59, 59, 0),
  //     key: "selection",
  //   },
  // ]);

  useEffect(() => {
    if (dimensions.width < 768) {
      setDirection("horizontal");
      setVAlign("top");
      setLAlign("left");
      setChartWidth(300);
    } else {
      setDirection("vertical");
      setVAlign("middle");
      setLAlign("right");
      setChartWidth(450);
    }
  }, [dimensions]);

  highcharts3d(Highcharts);
  const options = {
    colors: [
      "#6735A8",
      "#72ADFF",
      "#00C74C",
      "#FF6A3A",
      "#FFB53A",
      "#1e6c70",
      "#b01098",
      "#b0105d",
      "#edce05",
    ],
    chart: {
      type: "pie",
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0,
      },
      width: chartWidth,
      height: 300,
    },
    title: {
      text: "",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },

    legend: {
      enabled: true,
      layout: direction,
      verticalAlign: vAlign, //middle
      align: lAlign,
      squareSymbol: true,
      symbolHeight: 10,
      symbolWidth: 10,
      symbolRadius: 0,
      itemMarginTop: 10,
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        depth: 35,
        dataLabels: {
          enabled: false,
          format: "{point.name}",
        },
        showInLegend: true,
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        type: "pie",
        name: "Rewards Breakdown",
        data: rewards,
      },
    ],
  };

  useEffect(() => {
    getAllRewards();
  }, [state]);

  const getAllRewards = async () => {
    setLoading(true);
    try {
      const {
        data: { data },
      } = await restService.Dashboard.getRewards(
        campaign.id,
        new Date(state[0].startDate).toISOString().split("T")[0],
        new Date(state[0].endDate).toISOString().split("T")[0]
      );

      const tempArr = [];

      data.map((item) => {
        if (item.reward.rewardType.toLowerCase() === "airtime") {
          tempArr.push([
            `GHS ${item.reward.amount} ${item.reward.rewardType}`,
            Number(item.amountWon) / Number(item.reward.amount),
          ]);
        } else {
          tempArr.push([
            item.reward.rewardType,
            Number(item.amountWon) / Number(item.reward.amount),
          ]);
        }
      });

      setRewards(tempArr);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="shadow mb-8 bg-white py-6 px-6 w-full">
      <div className="flex mb-6 flex-col md:gap-0 gap-5 md:flex-row md:items-center md:justify-between">
        <p className="text-[#181818] text-base">Rewards Breakdown</p>

        {/* <div className="border rounded">
          <DatePicker state={state} setState={setState} />
        </div> */}
      </div>

      {loading ? (
        <>
          <div className="h-full w-full flex items-center justify-center">
            <PulseLoader color="#FF6A3A" />
          </div>
        </>
      ) : (
        <>
          {rewards.length < 1 ? (
            <div className="w-full flex justify-center mt-20 mb-20 ">
              <img src={require("../../../assets/images/noData.svg")} alt="" />
            </div>
          ) : (
            <div
              className={`grid w-full md:grid-cols-[repeat(auto-fit,minmax(500px,_1fr))] grid-cols-[repeat(auto-fit,minmax(300px,_1fr))]`}
            >
              <div className="  w-full ">
                <HighchartsReact
                  // containerProps={{ style: { height: "100%" } }}
                  highcharts={Highcharts}
                  // options={formatChartData(chartData.total, "Total")}
                  options={options}
                  // constructorType={"stockChart"}
                  updateArgs={[true, true, true]}
                />
              </div>
              <div className="w-full">
                <table className=" w-full">
                  <thead className="bg-[#F4F4F4] rounded h-14 w-full">
                    <tr className="w-full">
                      <th className=" md:w-[70%] w-[60%] text-left text-xs md:text-sm pl-6 text-[#24211D]">
                        Reward
                      </th>

                      <th className=" text-left mr-2 pl-6 text-xs md:text-sm text-[#24211D]">
                        Number of wins
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {rewards.map((item, index) => (
                      <tr key={index} className="  border-b">
                        <td className="text-left text-xs md:text-sm text-[#787878] py-3 pl-6">
                          {item[0]?.toLowerCase().includes("momo")
                            ? "GHS "
                            : ""}
                          {item[0].replace("_", " ")}
                        </td>
                        <td className="text-right pr-7 text-xs md:text-sm text-[#00C74C] py-3 pl-6">
                          {/* */}
                          {item[1] ?? 0}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PieChart;
